import { MdGroup } from 'react-icons/md';
import SectionLabelWithAccent from 'components/typography/SectionLabelWithAccent';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { DEFAULT_SECONDARY_COLOUR } from 'shared/constants/styleConstants';
import { fontSemiBold } from './styleConstants';

export default function Passenger({
  xMargins = {},
  marginTop = {},
  marginBottom = {},
}) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <>
      <SectionLabelWithIcon
        label="Passenger Group 1"
        icon={<MdGroup style={{ fill: primaryColour }} />}
        iconClassName="text-2xl"
        style={{
          paddingBottom: '1rem',
          borderBottomWidth: '1px',
          ...xMargins,
          ...marginTop,
        }}
        isPdf
      />
      <div
        style={{
          marginTop: '1rem',
          marginBottom: '1rem',
          ...xMargins,
          ...marginBottom,
        }}
      >
        <SectionLabelWithAccent
          label="Passengers"
          style={{ fontWeight: fontSemiBold }}
          accentColour={DEFAULT_SECONDARY_COLOUR}
        />
        <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>2 Adults</div>
      </div>
    </>
  );
}
